import React, {memo} from "react";
import Label from "components/general/Label"
import { arraysEqual } from "helpers/utils";

export const TableExpanded = memo((props) => {
    const {row, config} = props;
    const results = row?.recordDataFiltered?.recordExtensions?.filter(r => r?.code === 'INTERMEDIATE');
    const intermediates = config?.extendedConfig?.filter(cfg => cfg?.code === 'INTERMEDIATE')?.map(i => ({pos: i?.pos, value : i?.value}));

    const fullData = results?.map(res => {
        const intermediate = intermediates?.find(i => i?.pos === res?.pos)?.value;
        return ({pos:res?.pos, value:res?.value, intermediate:intermediate});
    });

    fullData?.sort((a, b) => (a?.pos === 'F' ? 100 : a?.pos === 'S' ? 0 : a?.pos) - (b?.pos === 'F' ? 100 : b?.pos === 'S' ? 0 : b?.pos))?.map(i => ({pos: i?.pos, value : i?.value}));


    let data
    if (fullData.length > 5) {
        data = [...fullData.slice(0,3), {pos:'4', value:'', intermediate:'...'}, ...fullData.slice(-2)]
    } else {
        data = fullData
    }

    const rows = data?.map(item => (
        <tr key={item?.pos}>
            <td className="fw-bold"><Intermediate data={item} /></td>
            <td className="text-end">{item?.value}</td>
        </tr>
    ));

    return (
        <table className="w-20">
            <thead>
                <tr>
                    <td className="fw-bold"><Label data={'HeaderDistance'} /></td>
                    <td className="fw-bold text-end"><Label data={'HeaderTime'} /></td>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </table>
    );


}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    //return false;
    return arraysEqual(prevProps?.row.recordDataFiltered.recordExtensions, nextProps?.row.recordDataFiltered.recordExtensions);
});

const Intermediate  = ({data}) => {
    return data?.pos === 'F' ? <Label data={'HeaderFinal'} /> : data?.intermediate === '...' ? <>{data?.intermediate}</> : <>{data?.intermediate}m</>

}